import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=779a6466&scoped=true&"
import script from "./EditMessage.vue?vue&type=script&lang=js&"
export * from "./EditMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditMessage.vue?vue&type=style&index=0&id=779a6466&prod&lang=scss&scoped=true&"
import style1 from "./EditMessage.vue?vue&type=style&index=1&id=779a6466&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a6466",
  null
  
)

export default component.exports